<!--
  Typically placed on top of a form input.
-->
<script setup lang="ts">
import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'

type Size = 'small' | 'medium' | 'large'
type Props = {
  // The text of the label.
  label?: string

  // Whether the field the label is attached to is required.
  required?: boolean | string

  // Whether the field the label is attached to has an error.
  hasErrors?: boolean

  // Hint to display as tooltip next to the label.
  hint?: string | object

  // Size of the label text.
  size?: Size
}

withDefaults(defineProps<Props>(), { size: 'large', })

const textSize = ({
  small: 'text-sm',
  medium: 'text-base',
  large: 'text-base',
} as Record<Size, string>)[__props.size]

const iconSize = ({
  small: 'xs',
  medium: 'xs',
  large: 'sm',
} as Record<Size, string>)[__props.size]
</script>

<template>
  <label
    class="text-left flex items-center cursor-inherit
      text-pretty whitespace-pre-wrap font-semibold text-navy label"
    :class="textSize"
  >{{ label }}<span
    v-if="required"
    class="ml-1 required-indicator"
    title="This field is required"
    :class="hasErrors && 'text-red-base'"
  >*</span><GIcon
    v-if="hint"
    v-tooltip="typeof hint === 'string' ? { content: hint, placement: 'right' } : hint"
    class="hint cursor-pointer text-v2-tertiary mx-1.5"
    :icon="faCircleInfo"
    :size="iconSize"
  /><slot/></label>
</template>
